/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @typedef {Object} DataSourceInfo
 * @property {String} [assetId] - The Cognos Content Store ID of the data source
 * @property {String} [searchPath] - The Cognos Content Store searchPath of the data source
 * @property {String} [name] - Name of the source.  Required if you don't specify the assetId property
 * @property {String} [type] - The type of the source.  Only needed if using assetId
 * @property {String} [clientId] - Identifier for the source.  Will be passed back for actions such as relink. Mostly used if you're not using the assetId property
 * @property {String} [module] - The module definition.  Only needed if not using a data source stored in the Content Store
 */

/**
  * @typedef {Object} PickTreeContext
  * @property {String} [type] The type indicating the context of where the pick tree is requested to be rendered. This can typically be the slot type.
  * @property {MetadataColumnAPI} [metadataColumn] The current selected metadata of the pick tree. undefined if no metadata is currently selected.
  */